import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".site-about-edit";

export default function loadEditAbout(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
